import { agent } from '../utils/agent'
const API_URL = process.env.REACT_APP_API_URL

// PlayHQ (play.cricket.com.au) import. A scope is { type: 'season' | 'grade' | 'match', id }.
const getLink = async () => {
  const response = await agent.get(`${API_URL}playhq/link`)
  return response.data
}
const saveLink = async (url) => {
  const response = await agent.post(`${API_URL}playhq/link`, { url })
  return response.data
}
const removeLink = async () => {
  const response = await agent.post(`${API_URL}playhq/unlink`)
  return response.data
}
const resolveScope = async (url) => {
  const response = await agent.post(`${API_URL}playhq/scope`, { url })
  return response.data
}

// Body: grade_ids (PlayHQ ids), active. Deactivated grades are left out of the other tabs.
const setGradesActive = async (data) => {
  const response = await agent.post(`${API_URL}playhq/grades/active`, data)
  return response.data
}

const preview = async (type, data) => {
  const response = await agent.post(`${API_URL}playhq/preview/${type}`, data)
  return response.data
}
const runImport = async (type, data) => {
  const response = await agent.post(`${API_URL}playhq/import/${type}`, data)
  return response.data
}

// Auto sync. Days are 0 = Sunday … 6 = Saturday, in the game's timezone.
const getAutoSync = async () => {
  const response = await agent.get(`${API_URL}playhq/auto-sync`)
  return response.data
}
// Body: auto_sync, sync_start_day, sync_end_day.
const saveAutoSync = async (data) => {
  const response = await agent.post(`${API_URL}playhq/auto-sync`, data)
  return response.data
}
// Body: round_id, days_before (1-3) - how long before the round starts its fixtures sync.
const saveRoundSyncDays = async (data) => {
  const response = await agent.post(`${API_URL}playhq/auto-sync/round`, data)
  return response.data
}
// Body: round_id or fixture_id - syncs that round's not-started fixtures, or that one fixture.
const runAutoSync = async (data) => {
  const response = await agent.post(`${API_URL}playhq/auto-sync/run`, data)
  return response.data
}

const PlayHQService = {
  getLink,
  saveLink,
  removeLink,
  resolveScope,
  setGradesActive,
  preview,
  runImport,
  getAutoSync,
  saveAutoSync,
  saveRoundSyncDays,
  runAutoSync,
}

export default PlayHQService
